import React, { useState } from 'react';
import Page from 'components/page/Page';
import { useAccessControlList } from 'hooks/access/useAccessControlList';
import { AdgangAccessControl } from 'api/adgang';
import { Button, LoadingSpinner } from 'common.ui';
import { devToolsApi } from 'api/AdgangClients';
import { useMsal } from 'auth/MsalContext';
import UserImportForm from './UserImportForm';

function DevTools() {
  const [, hasAccess] = useAccessControlList();
  const { logout } = useMsal();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onMakeAdmin = async () => {
    setIsLoading(true);
    try {
      const resp = await devToolsApi.apiDevToolsAdgangAdministratorRightsPost();
      if (resp && resp.length > 0) {
        setIsLoading(false);
        logout();
      } else {
        setIsLoading(false);
      }
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };

  if (isLoading) return <LoadingSpinner />;

  return (
    <Page header='Test verktøy' title='Test verktøy'>
      {hasAccess(AdgangAccessControl.HangfireDashboardView) && (
        <div>
          <Button onClick={onMakeAdmin} text='Tildel system administrator rolle' />
        </div>
      )}
      
      <div style={{ marginTop: '30px' }}>
        <UserImportForm />
      </div>
    </Page>
  );
}

export default DevTools;
